import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CommunityActions from './community.actions';
import { CommunityService } from '../../services/community.service';

@Injectable()
export class CommunityEffects {
  loadCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunityActions.loadCommunity),
      exhaustMap((_) =>
        this.communityService.getCommunity().pipe(
          map((data) =>
            CommunityActions.loadCommunitySuccess({ community: data })
          ),
          catchError((error) =>
            of(CommunityActions.loadCommunityFailure({ error }))
          )
        )
      )
    )
  );

  addCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunityActions.addCommunity),
      concatMap(({ newCommunity }) =>
        this.communityService.createCommunity(newCommunity).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return CommunityActions.addCommunitySuccess({ newCommunity: data });
          }),
          catchError((error) =>
            of(
              CommunityActions.addCommunityFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunityActions.updateCommunity),
      map((action) => action.updateCommunity),
      concatMap((updateCommunity) =>
        this.communityService.updateCommunity(updateCommunity).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return CommunityActions.updateCommunitySuccess({
              updateCommunity: updateCommunity,
            });
          }),
          catchError((error) =>
            of(
              CommunityActions.updateCommunityFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  removeCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CommunityActions.removeCommunity),
      map((action) => action.ids),
      concatMap((ids) =>
        this.communityService.deleteCommunity(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CommunityActions.removeCommunitySuccess({ ids });
          }),
          catchError((error) =>
            of(
              CommunityActions.updateCommunityFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private communityService: CommunityService,
    private notification: NotificationService
  ) {}
}
